var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar',{staticClass:"bg-yellow"}),_c('transition',{attrs:{"enter-active-class":"animated fadeIn faster"}},[_c('router-view')],1),_c('Footer',{staticClass:"bg-yellow"}),_c('CopyRight',{staticClass:"bg-yellow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }